export function normalizePhone(value) {
  const raw = String(value ?? '').trim();
  if (!/^\+?[0-9\s()-]+$/.test(raw)) return null;
  let digits = raw.replace(/\D/g, '');
  if (/^0[0-9]{9}$/.test(digits)) digits = '38' + digits;
  return /^380[0-9]{9}$/.test(digits) ? digits : null;
}
